<template>
    <section class="page-badges row">
        <div class="wrapper">
            <loading-spinner v-show="loading" />

            <h2 v-if="!loading && achievementsLength === 0"
                class="no-badges"
            >
                {{ $t('rewards.badges.noBadges') }}
            </h2>

            <div v-if="!loading && achievementsLength > 0"
                class="badges"
            >
                <badge-list v-for="(group, groupIndex) in achievements"
                    :key="groupIndex"
                    :badges="group.badges"
                    :title="groupTitle(group)"
                />
            </div>
        </div>
    </section>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Shared Modules
import badgesStoreTypes from '@shared/store/modules/rewards/badges/types.ts';
import {
    EventNames,
} from '@shared/utils/analytics-keys';

// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import badgeList from '@webapp/modules/rewards/components/badges/badge-list.vue';

export default {
    name: 'rewards',
    components: {
        badgeList,
        loadingSpinner,
    },
    data() {
        return {
            loading: true,
            achievements: [],
            achievementsLength: 0,
        };
    },
    computed: {
        ...mapGetters(['getTranslatedStr']),

        ...mapGetters('badges', ['groupedAchievements']),

        ...mapGetters('voteTokens', ['signedPartnersByTokenAmount']),
    },
    async mounted() {
        await this.getAchievements();

        this.achievements = this.groupedAchievements;
        this.achievementsLength = this.achievements.length;
        this.loading = false;
        this.$webTrackingInstance?.sendEvent(EventNames.AchievementsLobby);
    },
    methods: {
        ...mapActions('badges', {
            getAchievements: badgesStoreTypes.GET_ACHIEVEMENTS,
        }),

        groupTitle(group) {
            if (group.groupName === 'other') {
                return this.$t('rewards.badges.groupTitleOther');
            }

            if (group.translations && group.translations.length) {
                return this.getTranslatedStr(group, 'name', group.groupName);
            }

            return group.groupName;
        },
    },
};
</script>
<style lang="scss" scoped>
.page-badges {
    .no-badges {
        margin: 10rem 0;
        width: 100%;
        color: $daintree-color;
        text-align: center;
    }

    .badges {
        padding: 0;
        margin-top: 4rem;

        .badge-list {
            margin: 0;
        }
    }
}
</style>